import { render } from "./FaqSideNavigation.vue?vue&type=template&id=efe43d80&scoped=true"
import script from "./FaqSideNavigation.vue?vue&type=script&lang=js"
export * from "./FaqSideNavigation.vue?vue&type=script&lang=js"

import "./FaqSideNavigation.vue?vue&type=style&index=0&id=efe43d80&scoped=true&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe43d80"]])

export default __exports__